module.exports = __webpack_public_path__ + "img/laddercontrol1.f628db2f.png";